import { UniformSlot } from '@uniformdev/canvas-react';

const UniformContextualBanditsVariant = () => {
	return <UniformSlot name="content" />;
};

export default UniformContextualBanditsVariant;
